import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isAuthenticated, isCompanySelected } from '../store/selectors/AuthSelectors';

export const CompanyRoute = ({ component: Component, ...rest }) => {
  const userIsAuthenticated = useSelector(isAuthenticated);
  const companyIsSelected = useSelector(isCompanySelected);

  if (!userIsAuthenticated) {
    return (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: rest.location }
        }}
      />
    );
  }

  if (!companyIsSelected) {
    console.log('Company not selected, redirecting to company selection');
    return <Redirect to="/select-company" />;
  }

  return (
    <Route
      {...rest}
      render={(props) => <Component {...props} />}
    />
  );
};
